
import axios from "axios";
import moment from "moment";
import { cookiesHandler } from "../../utils/cookie_handler.js";
var instance = axios.create({
    baseURL: window.location.origin,
});


export default {
    namespaced: true,
    state: {
        sortedList: [],
        dateUpdated: "",
        isPlayed: false,
        learnFeaturedVideo: {
            videoArticle: "",
            videoSubtitle: "",
            videoTitle: "",
            videoUrl: "",
        },
        videos: [],
        playedVideo: {
            videoArticle: "",
            videoSubtitle: "",
            videoTitle: "",
            videoUrl: "",
        },
        videoItem: {
            videoArticle: "",
            videoSubtitle: "",
            videoTitle: "",
            videoUrl: "",
        },
        dailyNotesContent: {
            date: "",
            stockRecommendation: {
                stockSymbol: "",
                entryPrice: "",

            },
            templates: {

            },
            title: "",
            isDailyNotes: true,
            showBullMeter: false,
        },
        dailyNote: {

            title: "",
            date: "",
            stockRecommendation: {
                stockSymbol: "",
                entryPrice: 0,
                targetPrice: 0,
                potentialUpside: "",
                article: "",
            }
        },
        reits: {},
        latestDailyNotes: {},
        earningScorecard: {},
        sharesBuyback: {},
        preferredShares: {},
        weeklyNotes: {
            title: "",
            date: "",
            stockRecommendation: {
                stockSymbol: "",
                entryPrice: 0,
                targetPrice: 0,
                potentialUpside: "",
                article: "",
            }
        },
        marketSnapshots: {date:"", list:[]},
        morningPrimer: {date:"",list:[]},
        marketRecap: {date:"",
        list:[]},
        DailyNotesItem: {},
        morningPrimerContent: [],
        marketRecapContent: [],
        fullReport: {
            stockRecommendations: {
                "stockSymbol": "",
                "entryPrice": 0,
                "targetPrice": 0,
                "potentialUpside": "",
                "article": ""
            }
        },
        tradingGuidanceContent: {},
        ReportsContent: {
            dailyNotes: {
                title: "",
                date: "",
                reference: "",
            },
            sharesBuyback: {
                date: "",
                table: "",
            },
            earningScoreCard: {
                title: "",
                date: "",
                templates: [],
            },

            preferredShares: {
                date: "",

            },
            reits: {
                reitsStocks: "",
            },
            upcomingDividends: {
                date: "",
                dateUpdated: "",
                dividendsList: [],
            },

            shareBuyback: {
                date: "",
            },
            stockMomentum: {
                templates: []
            }
        },
        investorsNeedToKnow: [],
        tsupitHerosCornerContent: {
            stockRecommendations: {
                "stockSymbol": "",
                "entryPrice": 0,
                "targetPrice": 0,
                "potentialUpside": "",
                "article": ""
            },

            sortedList: [],
        },

        LearnContent: {
            playlistContent: {
                videoSubtitle: "",
                videoTitle: "",
                videoUrl: "",
            }
        },
        DailyNotes: {},
        stocksWithMomentum: {},
        kapitmanArchive: [],
        tsupitHeroArchive: [],
        KapitsmanCornerContent: [],
        kapitsmanCornerContent: {
            stockRecommendations: {
                "stockSymbol": "",
                "entryPrice": 0,
                "targetPrice": 0,
                "potentialUpside": "",
                "article": ""
            }
        },
        HomeContent: {
            kapitmansCornerItem: {
                content: "",
                date: "",
                subtitle: "",
                title: "",
            },

            tsupitHerosCorner: {
                content: "",
                date: "",
                subtitle: "",
                title: "",
            },
            philstocksForecast: {
                earningsGrowth: "",
                gdpGrowth: "",
                inflationRate: "",
                pSeiYearEndTarget: "",
                perYearEnd: "",
            },
            weeklyNotes: {
                date: "",
                stockRecommendation: {},
                templates: [],
                title: "",
            },
            featuredVideo: { url: "", videoTitle: "", },
            otherReport: {
                title: "",
                source: "",
            }
        },
        stocksWithMomentumContent: {
            date: "",
            templates: [],
        },
        companyReportContent: {
            date: "",
            templates: [],
        },
        ipoReportContent: {
            date: "",
            templates: [],
        },
        tradingPlanReportContent: {
            date: "",
            templates: [],
        },
        tradersNeedToKnowContent: {
            date: "",
            templates: [],
        },
        philstocksForecastContent: {
            date: "",
            templates: [],
        },
        tradingStrategiesContent: {
            date: "",
            templates: [],
        },
        investingStrategiesContent: {
            date: "",
            templates: [],
        },

        ipoPerformanceContent: {
            date: "",
            templates: [],
            ipoPerformance:[]
        },

        offeringsTableContent: {
            date: "",
            templates: [],
            offeringsTable:[]
        },
        pseiDividendYieldContent: {
            date: "",
            templates: [],
            psEiDividendYield:[]
        },

        economicReportsContent: {
            date: "",
            templates: [],
        },

        
        dailyNotesArchive: [],
        weeklyNotesArchive: [],
        morningPrimerArchive: [],
        marketRecapArchive: [],
        preferredSharesArchive: [],
        reitsArchive: [],
        earningScorecardArchive: [],
        shareBuybackArchive: [],
        marketSnapshotsArchive: [],
        stocksWithMomentumArchive: [],
        companyReportArchive: [],
        ipoReportArchive: [],
        tradingPlanReportArchive: [],
        tradersNeedToKnowArchive: [],
        philstocksForecastArchive: [],
        tradingStrategiesArchive: [],
        investingStrategiesArchive: [],
        economicReportsArchive:[],
        calendarAttribute: [],
        ipoPerformanceArchive:[],
        offeringsTableArchive:[],
        pseiDividendYield:[],
        latestMorningPrimer:{
            date:"",
            list:[],     
        },
        upcomingDividends: {
            date: "",
            dateUpdated: "",
            dividendsList: [],
        },
        learningGuideArchive:[],
        learningGuideReport: {
           
        },

    },
    getters: {
        attributes(state,) {
            return state.calendarAttribute;
        }
    },
    modules: {},
    mutations: {

        SET_HomeContent(state, payload) {
            state.HomeContent = payload;
            state.tsupitHerosCornerContent = payload.tsupitHeroCornerItem;
            state.kapitsmanCornerContent = payload.kapitmanCornerItem;
        },
        RESET_HomeContent(state) {
            state.HomeContent = "";
            state.marketSnapshotArchive = [];
        },
        SET_TsupitHerosContent(state, payload) {
            state.TsupitHerosCornerContent = payload;
            payload.tsupitHeroCornerList.forEach((item) => {
                state.tsupitHeroArchive.push(item)
            });
        },
        RESET_TsupitHerosContent(state) {
            state.TsupitHerosCornerContent = "";
        },

        SET_KapitmanCornerContent(state, payload) {
            state.KapitsmanCornerContent = payload;
            payload.kapitmanCornerList.forEach((item) => {
                state.kapitmanArchive.push(item)

            });

        },
        RESET_SET_KapitmanCornerContent(state) {
            state.KapitsmanCornerContent = "";
        },

        SET_IsPlayedVideo(state, payload) {
            state.playedVideo = payload;
        },
        RESET_IsPlayedVideo(state) {
            state.playedVideo = "";
        },

        SET_SelectedVideo(state, payload) {
            state.playedVideo = payload.video;
        },
        RESET_SelectedVideo(state) {
            state.playedVideo = "";
        },

        // SET_DailyNotes(state, payload) {
        //     state.dailyNotesContent = payload;
        // },
        // RESET_DailyNotes(state) {
        //     state.dailyNotesContent = "";
        // },

        SET_ReportPage(state, payload) {
            state.ReportsContent = payload;
            state.upcomingDividends = payload.upcomingDividends;
            var list = [];
            payload.upcomingDividends.dividendsList.forEach(el => {
                list.push(el)
                list.sort((a, b) => new Date(b.exDate) - new Date(a.exDate));
                state.sortedList = list;
            });
        },
        RESET_ReportPage(state) {
            state.ReportsContent = "";
            state.fullReport = "";
        },

        SET_LearnContent(state, payload) {
            state.LearnContent = payload;
            var chapter = [];
            payload.learnVideos.forEach(element => {
                element.subPlaylist.forEach(el => {
                    chapter.push(el.videos[0]);
                    var item = [];
                    item.push(chapter[0])
                    let obj = {};
                    obj = item[0];

                    state.featuredVideo = obj;
                });
            });
        },
        SET_CalendarEvents(state, payload) {
           
            var attributes = [];
            var events = [];
            events.push(payload.marketCalendar)
            const latest = events.reduce(function (r, a) {
                return r.dateUpdated
                > a.dateUpdated
                ? r : a;
            });
            state.dateUpdated =  moment.utc(latest[0].dateUpdated).format('LLL');

            payload.marketCalendar.forEach((el, index) => {
                
                attributes.push({
                    key: index + 1,
                    customData: {
                        title: el.eventName,
                        class: 'bg-red-600 text-black',
                    },
                    dates: moment(el.date).format("YYYY-MM-DD"),
                })
                
            });
            state.calendarAttribute = attributes;
        },
        RESET_CalendarEvents(state) {
            state.calendarAttribute = [];
        },
        SET_FullReport(state, payload) {

            state.fullReport = payload;
        },
        RESET_FullReport(state) {
            state.fullReport = {};
        },
        SET_WeeklyNotes(state, payload) {
            state.weeklyNotes = payload.weeklyNotes;
        },
        RESET_WeeklyNotes(state) {
            state.weeklyNotes = {};
        },

        SET_DailyNotesItem(state, payload) {

            state.dailyNote = payload.dailyNotes;
        },
        RESET_DailyNotesItem(state) {

            state.dailyNote = {};
        },

        RESET_LearnContent(state) {
            state.LearnContent = "";
            state.featuredVideo = "";
        },
        SET_REITS(state, payload) {
            state.reits = payload.reits;
        },
        RESET_REITS(state) {
            state.reits = {};
        },

        SET_PreferredShares(state, payload) {
            state.preferredShares = payload.preferredShares
        },
        RESET_PreferredShares(state) {
            state.preferredShares = {};
        },

        SET_SharesBuyback(state, payload) {
            state.sharesBuyback = payload.shareBuyback
        },
        RESET_SharesBuyback(state) {
            state.sharesBuyback = {};
        },

        SET_EarningScorecard(state, payload) {
            state.earningScorecard = payload.earningScoreCard
        },
        RESET_EarningScorecard(state) {
            state.earningScorecard = {};
        },

        SET_StocksWithMomentum(state, payload) {
            state.stocksWithMomentumContent = payload.stocksWithMomentum
        },
        RESET_StocksWithMomentum(state) {
            state.stocksWithMomentumContent = {};
        },

        SET_CompanyReport(state, payload) {
            state.companyReportContent = payload.companyReport
        },
        RESET_CompanyReport(state) {
            state.companyReportContent = {};
        },
        SET_IPOReport(state, payload) {
            state.ipoReportContent = payload.ipoReport
        },
        RESET_IPOReport(state) {
            state.ipoReportContent = {};
        },

        SET_TradingPlanReport(state, payload) {
            state.tradingPlanReportContent = payload.tradingPlanReport
        },
        RESET_TradingPlanReport(state) {
            state.tradingPlanReportContent = {};
        },

        SET_TradersNeedToKnow(state, payload) {
            state.tradersNeedToKnowContent = payload.tradersNeedToKnow
        },
        RESET_TradersNeedToKnow(state) {
            state.tradersNeedToKnowContent = {};
        },

        SET_PhilstocksForecast(state, payload) {
            state.philstocksForecastContent = payload.philstocksForecast
        },
        RESET_PhilstocksForecast(state) {
            state.philstocksForecastContent = {};
        },
        SET_TradingStrategies(state, payload) {
            state.tradingStrategiesContent = payload.tradingStrategies
        },
        RESET_TradingStrategies(state) {
            state.tradingStrategiesContent = {};
        },
        SET_InvestingStrategies(state, payload) {
            state.investingStrategiesContent = payload.investingStrategies
        },
        RESET_InvestingStrategies(state) {
            state.investingStrategiesContent = {};
        },
        SET_DailyNotesArchive(state, payload) {
            state.dailyNotesArchive = payload.dailyNotesArchive
        },
        RESET_DailyNotesArchive(state) {
            state.dailyNotesArchive = [];
        },

        SET_WeeklyNotesArchive(state, payload) {
            state.weeklyNotesArchive = payload.weeklyNotesList
        },
        RESET_WeeklyNotesArchive(state) {
            state.weeklyNotesArchive = [];
        },

        SET_MorningPrimerArchive(state, payload) {
            state.morningPrimerArchive = payload.morningPrimerList;

        },
        RESET_MorningPrimerArchive(state) {
            state.morningPrimerArchive = [];
        },

        SET_MarketRecapArchive(state, payload) {
            state.marketRecapArchive = payload.marketRecapList;
        },
        RESET_MarketRecapArchive(state) {
            state.marketRecapArchive = [];
        },
        SET_PreferredSharesArchive(state, payload) {
            state.preferredSharesArchive = payload.preferredSharesList;
        },
        RESET_PreferredSharesArchive(state) {
            state.preferredSharesArchive = [];
        },
        SET_REITsArchive(state, payload) {
            state.reitsArchive = payload.reitsList;
        },
        RESET_REITsArchive(state) {
            state.reitsArchive = [];
        },
        SET_EarningScorecardArchive(state, payload) {
            state.earningScorecardArchive = payload.earningScorecardList;
        },
        RESET_EarningScorecardArchive(state) {
            state.earningScorecardArchive = [];
        },
        SET_ShareBuybackArchive(state, payload) {
            state.shareBuybackArchive = payload.sharesBuybackList;
        },
        RESET_ShareBuybackArchive(state) {
            state.shareBuybackArchive = [];
        },
        SET_MarketSnapshotArchive(state, payload) {
            state.marketSnapshotsArchive = payload.marketSnapshotsList;
        },
        RESET_MarketSnapshotArchive(state) {
            state.marketSnapshotsArchive = [];
        },
        SET_StocksWithMomentumArchive(state, payload) {
            state.stocksWithMomentumArchive = payload.stocksWithMomentumList;
        },
        RESET_StocksWithMomentumArchive(state) {
            state.stocksWithMomentumArchive = [];
        },

        SET_CompanyReportArchive(state, payload) {
            state.companyReportArchive = payload.companyReportsList;
        },
        RESET_CompanyReportArchive(state) {
            state.companyReportArchive = [];
        },
        SET_IPOReportArchive(state, payload) {
            state.ipoReportArchive = payload.ipoReportList;
        },
        RESET_IPOReportArchive(state) {
            state.ipoReportArchive = [];
        },
        SET_TradingPlanReportArchive(state, payload) {
            state.tradingPlanReportArchive = payload.tradingPlanReportList;
        },
        RESET_TradingPlanReportArchive(state) {
            state.tradingPlanReportArchive = [];
        },
        SET_TradersNeedToKnowArchive(state, payload) {
            state.tradersNeedToKnowArchive = payload.tradersNeedToKnowList;
        },
        RESET_TradersNeedToKnowArchive(state) {
            state.tradersNeedToKnowArchive = [];
        },

        SET_PhilstocksForecastArchive(state, payload) {
            state.philstocksForecastArchive = payload.philstocksForecastList;
        },
        RESET_PhilstocksForecastArchive(state) {
            state.philstocksForecastArchive = [];
        },
        SET_InvestingStrategiesArchive(state, payload) {
            state.investingStrategiesArchive = payload.investingStrategiesList;
        },
        RESET_InvestingStrategiesArchive(state) {
            state.investingStrategiesArchive = [];
        },
        SET_LearningGuide(state, payload) {

            state.learningGuideArchive = []
            state.learningGuideArchive = payload.learningGuideList;
        },
        
        SET_TradingStrategiesArchive(state, payload) {
            state.tradingStrategiesArchive = payload.tradingStrategiesList;
        },
        RESET_TradingStrategiesArchive(state) {
            state.tradingStrategiesArchive = [];
        },

        RESET_IPOPerformanceArchive(state)
        {
            state.ipoPerformanceArchive = [];
        },

        SET_EconomicReportsArchive(state, payload) {
            state.economicReportsArchive = payload.economicReportsList;
        },

        RESET_EconomicReportsArchive(state) {
            state.economicReportsArchive = [];
        },

        SET_EconomicReports(state, payload) {
            state.economicReportsContent = payload.economicReports;
        },
        RESET_EconomicReports(state) {
            state.economicReportsContent = {};
        },
    

        SET_IPOPerformanceArchive(state, payload)
        {
            
            state.ipoPerformanceArchive = payload.ipoPerformanceList;
        },
        RESET_IPOPerformance (state)
        {
            state.ipoPerformanceContent = {};
        },
        SET_IPOPerformance (state, payload)
        {
            state.ipoPerformanceContent = payload.ipoPerformance
        },
        RESET_OfferingsTableArchive(state)
        {
            state.offeringsTableArchive = [];
        },
        SET_OfferingsTableArchive(state, payload)
        {
            state.offeringsTableArchive = payload.offeringsTablelist;
        },

        RESET_OfferingsTable(state)
        {
            state.offeringsTableContent = {};
        },
        SET_OfferingsTable(state, payload)
        {
            state.offeringsTableContent = payload.offeringsTable;
        },
        SET_PSEiDividendYieldArchive(state, payload)
        {
            state.pseiDividendYield = payload.psEiDividendYieldList
        },
        RESET_PSEiDividendYieldArchive(state)
        {
            state.pseiDividendYield = {}
        },
        SET_PSEiDividendYield(state, payload)
        {
            state.pseiDividendYieldContent = payload.psEiDividendYield
        },
        RESET_PSEiDividendYield(state)
        {
            state.pseiDividendYieldContent = {}
        },
        SET_LatestDailyNotes(state, payload)
        {
            state.dailyNotesContent = {};
           state.dailyNotesContent =  {
            date: payload.latestDailyNotes.date,
            stockRecommendation: {
                stockSymbol: payload.latestDailyNotes.stockRecommendation.stockSymbol,
                entryPrice:  payload.latestDailyNotes.stockRecommendation.entryPrice,
                potentialUpside :  payload.latestDailyNotes.stockRecommendation.potentialUpside,
                targetPrice: payload.latestDailyNotes.stockRecommendation.targetPrice,
                article:payload.latestDailyNotes.stockRecommendation.article,
            },
            templates: {

            },
            title:  payload.latestDailyNotes.title,
            isDailyNotes: payload.latestDailyNotes.isDailyNotes,
            showBullMeter:  payload.latestDailyNotes.showBullMeter,
            slider: payload.latestDailyNotes.slider,
            articleTitle: payload.latestDailyNotes.articleTitle
         }
     
        },
        SET_LatestMorningPrimer(state, payload)
        {
                state.morningPrimer = [];
                state.morningPrimer = payload.morningPrimer;
            
        },
        SET_LatestMarketRecap(state,  payload)
        {
 
            state.marketRecap = {};
            state.marketRecap = payload.marketRecap;
        },
        SET_LatestMarketSnapshot(state,  payload)
        {
     
            state.marketSnapshots = {};
            state.marketSnapshots= payload.marketSnapshot;
        },
        SET_LearningGuideReport(state,  payload)
        {
     console.log(payload);
            state.learningGuideReport = {};
            state.learningGuideReport= payload.learningGuide;
        },
        SET_UpcomingDividends(state, payload){
            state.upcomingDividends = {};
            state.upcomingDividends =  payload.upcomingDividends;
            var list = [];
            payload.upcomingDividends.dividendsList.forEach(el => {
                list.push(el)
                list.sort((a, b) => new Date(b.exDate) - new Date(a.exDate));
                state.sortedList = list;
            });
        },
        SET_InvestorsNeedToKnow(state, payload)
        {
            state.investorsNeedToKnow = [];
            var list = []
            payload.investorsNeedToKnow.forEach((item, index) => {
                var today = moment().format("L");
                list.push({
                    key: index + 1,
                    description: item.description,
                    image: item.image,
                    link: item.link,
                    title: item.title,
                    date: moment(item.date).format("L"),
                    isLatest: moment(item.date).format("L") == today ? true : false,
                })
            });
            state.investorsNeedToKnow = list;
        }
    },

    actions: {
        SET_IsSelectedVideo({ commit, state }, payload) {
            commit('RESET_IsPlayedVideo')
            commit('SET_IsPlayedVideo', payload)
            state.playedVideo = payload;
        },
        SET_FullReport({ commit }, payload) {
            commit('RESET_FullReport')
            commit('SET_FullReport', payload)
        },
        GetHomeContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Home/home", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_HomeContent')
                        commit('SET_HomeContent', response.data)

                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },
       
        GetDailyNotesContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Home/dailyNotes", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                  
                        commit('SET_LatestDailyNotes', response.data)

                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },
        GetLatestMorningPrimerContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Home/morningPrimer", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                  
                        commit('SET_LatestMorningPrimer', response.data)

                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },
        GetLatestMarketRecapContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Home/marketRecap", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                  
                        commit('SET_LatestMarketRecap', response.data)

                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },
        GetLatestMarketSnapshotContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Home/marketSnapshot", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                  
                        commit('SET_LatestMarketSnapshot', response.data)

                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },
        GetInvestorsNeedtoKnow({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Home/investorsNeedtoKnow", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                  
                        commit('SET_InvestorsNeedToKnow', response.data)

                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },


        GetUpcomingDividendstContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/upcomingDividends", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                  
                        commit('SET_UpcomingDividends', response.data)

                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetDailyNotes({ commit }, payload) {

            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/dailyNotes?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_DailyNotesItem')
                        commit('SET_DailyNotesItem', response.data)

                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetWeeklyNotes({ commit }, payload) {

            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/weeklyNotes?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_WeeklyNotes')
                        commit('SET_WeeklyNotes', response.data)
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetReits({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/reitsStocks?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_REITS')
                        commit('SET_REITS', response.data)
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetPreferredShares({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/preferredShares?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_PreferredShares')
                        commit('SET_PreferredShares', response.data)
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetSharesBuyback({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/sharesBuyback?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_SharesBuyback')
                        commit('SET_SharesBuyback', response.data)
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetEarningScorecard({ commit }, payload) {

            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/earningScorecard?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_EarningScorecard')
                        commit('SET_EarningScorecard', response.data)
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },


        GetStocksWithMomentum({ commit }, payload) {

            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/stocksWithMomentum?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_StocksWithMomentum')
                        commit('SET_StocksWithMomentum', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetCompanyReport({ commit }, payload) {
            var token = cookiesHandler.methods.getCookie("sessionToken")
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/companyReport?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + token
                        }
                    })
                    .then(function (response) {
                        commit('RESET_CompanyReport')
                        commit('SET_CompanyReport', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetIPOReport({ commit }, payload) {

            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/ipoReport?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_IPOReport')
                        commit('SET_IPOReport', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetTradingPlanReport({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/tradingPlanReport?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_TradingPlanReport')
                        commit('SET_TradingPlanReport', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetTradersNeedToKnowReport({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/tradersNeedToKnow?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_TradersNeedToKnow')
                        commit('SET_TradersNeedToKnow', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetPhilstocksForecast({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/philstocksForecast?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_PhilstocksForecast')
                        commit('SET_PhilstocksForecast', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetTradingStrategies({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/tradingStrategies?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_TradingStrategies')
                        commit('SET_TradingStrategies', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },
        GetInvestingStrategies({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/investingStrategies?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_InvestingStrategies')
                        commit('SET_InvestingStrategies', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },


        GetLearnVideo({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/learn?keyword=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_SelectedVideo')
                        commit('SET_SelectedVideo', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },



        GetTsupitHeroContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/TsupitHeroCorner", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_TsupitHerosContent')
                        commit('SET_TsupitHerosContent', response.data)
                        resolve(response);

                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetKapitsmanContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/KapitmanCorner", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_SET_KapitmanCornerContent')
                        commit('SET_KapitmanCornerContent', response.data)
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetLearnContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Learn", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_LearnContent')
                        commit('SET_LearnContent', response.data)
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetReportsContent({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Reports", {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_ReportPage')
                        commit('SET_ReportPage', response.data)
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetDailyNotesArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/dailyNotesArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_DailyNotesArchive')
                        commit('SET_DailyNotesArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetWeeklyNotesArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/weeklyNotesArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_WeeklyNotesArchive')
                        commit('SET_WeeklyNotesArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetMorningPrimerArchive({ commit }, payload) {

            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/morningPrimerArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")

                        }

                    })
                    .then(function (response) {
                        commit('RESET_MorningPrimerArchive')
                        commit('SET_MorningPrimerArchive', response.data)

                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetMarketRecapArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/marketRecapArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_MarketRecapArchive')
                        commit('SET_MarketRecapArchive', response.data)

                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetPreferredSharesArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/preferresSharesArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_PreferredSharesArchive')
                        commit('SET_PreferredSharesArchive', response.data)

                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetREITsArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/reitsArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_REITsArchive')
                        commit('SET_REITsArchive', response.data)

                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },
        GetEarningScorecardArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/earningScorecardArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_EarningScorecardArchive')
                        commit('SET_EarningScorecardArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetShareBuybackArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/shareBuybackArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_ShareBuybackArchive')
                        commit('SET_ShareBuybackArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetMarketSnapshotsArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/marketSnapshotsArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_MarketSnapshotArchive')
                        commit('SET_MarketSnapshotArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },
        GetStocksWithMomentumArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/stocksWithMomentumArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_StocksWithMomentumArchive')
                        commit('SET_StocksWithMomentumArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },
        GetCompanyReportArchive({ commit }, payload) {

            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/companyReportArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_CompanyReportArchive')
                        commit('SET_CompanyReportArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },
        GetIPOReportArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/iPOReportArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_IPOReportArchive')
                        commit('SET_IPOReportArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },
        GetIPOPerformanceArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/iPOPerformanceArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        
                        commit('RESET_IPOPerformanceArchive')
                        commit('SET_IPOPerformanceArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetTradingPlanArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/tradingPlanReportArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_TradingPlanReportArchive')
                        commit('SET_TradingPlanReportArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetTradersNeedToKnowArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/tradersNeedToKnowArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_TradersNeedToKnowArchive')
                        commit('SET_TradersNeedToKnowArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetPhilstocksForecastArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/philstocksForecastArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_PhilstocksForecastArchive')
                        commit('SET_PhilstocksForecastArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetTradingStrategiesArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/tradingStrategiesArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_TradingStrategiesArchive')
                        commit('SET_TradingStrategiesArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetInvestingStrategiesArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/investingStrategiesArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_InvestingStrategiesArchive')
                        commit('SET_InvestingStrategiesArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },
        
        GetEconomicReportsArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/economicReportsArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_EconomicReportsArchive')
                        commit('SET_EconomicReportsArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },
        GetEconomicReports({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/economicReports?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_EconomicReports')
                        commit('SET_EconomicReports', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetMarketCalendarEvents({ commit }) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/marketCalendar",{
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_CalendarEvents')
                        commit('SET_CalendarEvents', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetIPOPeformance({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/ipoPerformance?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_IPOPerformance')
                        commit('SET_IPOPerformance', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetOfferingsTableArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/offeringsTableArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        
                        commit('RESET_OfferingsTableArchive')
                        commit('SET_OfferingsTableArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },
        GetOfferingsTable({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/offeringsTable?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_OfferingsTable')
                        commit('SET_OfferingsTable', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },
        GetPSEiDividendYieldArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
             
                    .get("/api/Content/pseiDividendYieldArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        
                        commit('RESET_PSEiDividendYieldArchive')
                        commit('SET_PSEiDividendYieldArchive', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetPSEiDividendYield({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/pseiDividendYield?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        commit('RESET_PSEiDividendYield')
                        commit('SET_PSEiDividendYield', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

        GetLearningGuideArchive({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/learningGuideArchive?dateFrom=" + payload.DateFrom + "&dateTo=" + payload.DateTo, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
                        
                        commit('SET_LearningGuide', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject(error.response);
                    });
            });
        },

        GetLearningGuideReport({ commit }, payload) {
            return new Promise((resolve, reject) => {
                instance
                    .get("/api/Content/learningGuide?date=" + payload, {
                        headers: {
                            Authorization: "Bearer " + cookiesHandler.methods.getCookie("sessionToken")
                        }
                    })
                    .then(function (response) {
               
                        commit('SET_LearningGuideReport', response.data)
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);

                        reject(error.response);
                    });
            });
        },

    }
}